export default {
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
  LOADING: 'LOADING'
};